import Home from './Home/home'

function Main (){    
    

    return(
        <>
            <Home />
        </>   
    );
}

export default Main;

// "npm start" para arrancar React.js